

























































































import { Component, Vue, Prop } from "nuxt-property-decorator";
import dayjs from "dayjs";
import UserIcon from "~/components/UserIcon.vue";
import { Calendar, Entry, User } from "~/types/adventar";
import { getToday } from "~/lib/Configuration";

@Component({
  components: { UserIcon }
})
export default class extends Vue {
  @Prop() readonly calendar: Calendar;
  @Prop() readonly currentUser: User;
  @Prop() readonly onCreateEntry: (day: number) => Promise<Entry>;
  @Prop() readonly onUpdateEntry: (
    entryId: number,
    { comment, url }: { comment: string; url: string }
  ) => Promise<void>;
  @Prop() readonly onDeleteEntry: (entryId: number) => Promise<void>;

  displayedDialogEntry: Entry | null;
  inputComment: string;
  inputUrl: string;
  dialogStyle: object;
  dialogArrowStyle: object;

  get rows() {
    const year = this.calendar.year;
    const endDay = dayjs(new Date(year, 11, 25));
    let currentDay = dayjs(new Date(year, 11, 1)).startOf("week");

    const entryMapByDay: { [key: number]: Entry } = {};
    if (this.calendar !== null && this.calendar.entries !== undefined) {
      this.calendar.entries.forEach(entry => {
        if (entry.day) {
          entryMapByDay[entry.day] = entry;
        }
      });
    }

    const rows: any[] = [];
    while (currentDay <= endDay) {
      const cells: any[] = [];
      for (let i = 0; i < 7; i++) {
        const isDecember = currentDay.month() === 11;
        const day = currentDay.date();
        const entry = (isDecember && entryMapByDay[day]) || null;
        const entryable = isDecember && day <= 25;
        const cell = { day, entry, entryable };
        cells.push(cell);
        currentDay = currentDay.add(1, "day");
      }
      rows.push(cells);
    }

    return rows;
  }

  mounted() {
    document.addEventListener("click", this.handleClickDocument);
    document.addEventListener("keyup", this.handleKeyupDocument);
  }

  destroyed() {
    document.removeEventListener("click", this.handleClickDocument);
    document.removeEventListener("keyup", this.handleKeyupDocument);
  }

  handleClickDocument() {
    this.hideDialog();
  }

  handleKeyupDocument(e) {
    if (e.key === "Escape") {
      this.hideDialog();
    }
  }

  data() {
    return {
      displayedDialogEntry: null,
      inputComment: "",
      inputUrl: ""
    };
  }

  forceCancelable(entry: Entry): boolean {
    return this.calendar !== null && !this.isOwnEntry(entry) && this.isOwnCalendar(this.calendar);
  }

  isOwnCalendar(calendar: Calendar): boolean {
    if (!this.$store.state.user) return false;
    if (!calendar.owner) return false;
    return calendar.owner.id === this.$store.state.user.id;
  }

  isOwnEntry(entry: Entry): boolean {
    if (!this.$store.state.user) return false;
    if (!entry.owner) return false;
    return entry.owner.id === this.$store.state.user.id;
  }

  showDialog(entry): void {
    const boxWidth = 338;
    const boxHeight = 180;
    const cell = this.$refs[`cell-${entry.day}`][0];
    const rect = cell.getBoundingClientRect();
    const cellCenterLeft = cell.offsetLeft + cell.clientWidth / 2;
    const windowLeftPadding = rect.left - cell.offsetLeft;
    let dialogLeft = cellCenterLeft - boxWidth / 2;
    if (dialogLeft < -windowLeftPadding) {
      dialogLeft = -windowLeftPadding;
    }
    if (dialogLeft + boxWidth > window.innerWidth - windowLeftPadding) {
      dialogLeft = window.innerWidth - windowLeftPadding - boxWidth;
    }
    this.dialogStyle = {
      top: `${cell.offsetTop - boxHeight + 5}px`,
      left: `${dialogLeft}px`
    };
    this.dialogArrowStyle = {
      left: `${cellCenterLeft - dialogLeft - 12}px`
    };
    this.inputComment = entry.comment;
    this.inputUrl = entry.url;
    this.displayedDialogEntry = entry;
    setTimeout(() => {
      (this.$refs.inputCommentElement as any).focus();
    });
  }

  hideDialog(): void {
    this.inputComment = "";
    this.inputUrl = "";
    this.dialogStyle = {};
    this.dialogArrowStyle = {};
    this.displayedDialogEntry = null;
  }

  isFutureEntry(entry): boolean {
    // TODO: Fix to JST
    return new Date(this.calendar.year, 11, entry.day) > getToday();
  }

  async handleClickCreateEntry(day: number): Promise<void> {
    if (!this.currentUser) {
      window.alert("登録にはログインが必要です。");
      return;
    }
    const entry = await this.onCreateEntry(day);
    this.showDialog(entry);
  }

  handleClickEditEntry(entry: Entry) {
    this.showDialog(entry);
  }

  handleClickDeleteEntry() {
    if (this.displayedDialogEntry === null) {
      throw new Error("Entry is not selected");
    }
    if (!window.confirm("登録をキャンセルします")) return;
    this.onDeleteEntry(this.displayedDialogEntry.id);
    this.hideDialog();
  }

  async handleSubmitEntryForm(): Promise<void> {
    if (this.displayedDialogEntry === null) {
      throw new Error("Entry is not selected");
    }
    const comment = this.inputComment;
    const url = this.inputUrl;
    await this.onUpdateEntry(this.displayedDialogEntry.id, { comment, url });
    this.hideDialog();
  }

  handleClickForceCancel(entry: Entry) {
    const message = "カレンダーの管理者に限りエントリーを強制的にキャンセルできます。キャンセルしますか？";
    if (window.confirm(message)) {
      this.onDeleteEntry(entry.id);
    }
  }
}
